const doc = [({"da":({"js":({"admin":({"users":({"show":({"you_have_been_signed_in_as_the_user":"Du er blevet logget ind som brugeren.", "sign_in_as":"Log ind som"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;